<theme-loader [cdnRoot]="assetURL"></theme-loader>
<ng-container *ngIf="isWelcomeScreen">
    <welcome (isWelcomeScreen)="loginIn()"></welcome>
</ng-container>
<ng-container *ngIf="!isWelcomeScreen">
    <div class="app-main-container">      
        <top-navigation></top-navigation>
        <div style="height: 100%;" *ngIf="signInDone">
            <div>
                <client-manager-view></client-manager-view>
            </div>
            <div>
                <loading-indicator displayId="rde-app"></loading-indicator>
            </div>
            <div class="app-page-content-container" [ngClass]="{'shelf--active' : isActiveShelf}">
                <router-outlet (activate)="closeDrawerIfOpen()"></router-outlet>
                <right-side-drawer></right-side-drawer>
            </div>
        </div>
    </div>

    <div *ngIf="signInDone && _topNavigationService.getShowFeedback()">
        <div class="feedback-holder">
            <img [src]="getThumbsUpIcon()" class="feedback-button-shadow" (click)="setLike(1)"
                (mouseover)="setThumbsUpHover(true)" (mouseout)="setThumbsUpHover(false)"/>
            <img [src]="getThumbsDownIcon()" class="feedback-button-shadow" (click)="setLike(3)"
                (mouseover)="setThumbsDownHover(true)" (mouseout)="setThumbsDownHover(false)"/>
            <img 
                [src]="getShowCommentIcon()" class="feedback-button-shadow" (click)="toggleFeedback()"
                (mouseover)="setShowCommentHover(true)" (mouseout)="setShowCommentHover(false)"/>
        </div>
        <div class="feedback-textbox-holder">
            <img *ngIf="showFeedbackTextInput" [src]="isCloseImgHover ? imgSrcCloseHover : imgSrcClose"
                class="feedback-button-shadow" (click)="toggleFeedback()"
                (mouseover)="setCloseHover(true)" (mouseout)="setCloseHover(false)" />
            <div *ngIf="showFeedbackTextInput" class="textbox-holder">
                <input type="text" [(ngModel)]="feedBack" class="feedback-textbox"
                    placeholder="We'd love to hear your feedback" name="feedback" [disabled]="isSendingFeedback"
                    [ngClass]="{'feedback-textbox-focus': isSendActive}" (focus)="isSendActive=true" />
                <img *ngIf="!isSendingFeedback" [src]="getSendFeedbackArrowIcon()"
                    (click)="setLike(feedBackStatus)" class="imgFeedbackSend feedback-button-shadow"
                    [ngClass]="{'imgFeedbackSend-active': isSendActive, 'imgFeedbackSend-inactive': !isSendActive }"
                    (mouseover)="setSendFeedbackHover(true)" (mouseout)="setSendFeedbackHover(false)" />
            </div>
        </div>
    </div>
</ng-container>
